var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"app-main"},[_c('tags-view'),_c('keep-alive',{attrs:{"include":_vm.cachedViews}},[_c('router-view',{staticClass:"body-container"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }